export const copernicoPalette = {
  primary: {
    50: '#FBF4DA',
    100: '#F9EFC8',
    200: '#F3E090',
    300: '#e7bf19',
    400: '#d7a64f',
    500: '#ce8042',
    main: '#e7bf19'
  },
  secondary: {
    50: '#59b1a5',
    100: '#4ea69b',
    200: '#48998e',
    300: '#3c8077',
    400: '#3b7d74',
    500: '#346f67',
    main: '#3c8077'
  },
  tertiary: {
    50: '#F2FFFF',
    100: '#FEF4D7',
    200: '#FDDD87',
    300: '#FAB805',
    400: '#F0B105',
    500: '#C89404',
    main: '#C89404'
  },
  green: {
    50: '#F2FFF9',
    100: '#E5FFF2',
    200: '#4CFFA6',
    300: '#00CC67',
    400: '#00994D',
    500: '#006633'
  },
  orange: {
    50: '#FFF8F2',
    100: '#FFF1E5',
    200: '#FFAC66',
    300: '#FF7500',
    400: '#CC5E00',
    500: '#662F00'
  },
  red: {
    50: '#FFF2F2',
    100: '#FFE5E5',
    200: '#FF9999',
    300: '#FF0000',
    400: '#CC0000',
    500: '#660000'
  },
  yellow: {
    50: '#FEFEE5',
    100: '#F3F3B2',
    200: '#F2F294',
    300: '#EEEE2C',
    400: '#DCC80F',
    500: '#6A5300'
  },
  grayscale: {
    50: '#fdfdfd',
    100: '#F4F5F6',
    200: '#EBECED',
    300: '#B4B5B8',
    400: '#9EA0A4',
    500: '#898B8F',
    600: '#73767A',
    700: '#5E6066',
    800: '#484B51'
  },
  transparent: {
    light: {
      95: '#EFF0F6F2',
      75: '#EFF0F6BF',
      65: '#EFF0F6A6',
      40: '#EFF0F666',
      25: '#EFF0F640',
      10: '#EFF0F61A'
    },
    dark: {
      95: '#14142BF2',
      75: '#14142BBF',
      65: '#14142BA6',
      40: '#14142B66',
      25: '#14142B40',
      10: '#14142B1A'
    }
  },
  white: '#FFFFFF',
  black: '#000000'
}
